import * as yup from 'yup'

export class MoveVehicleDto {
  vehicleGuid?: string = undefined
  vin?: string = undefined
  year?: number = undefined
  make?: string = undefined
  model?: string = undefined
  parkingSpace?: string = undefined
}

export const moveVehicleValidationSchema = yup.object({
  parkingSpace: yup
    .string()
    .max(200, 'Parking Space cannot be more than 200 characters.')
    .required('Parking Space is required.')
})
